import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  redirectToUsernamePasswordPage,
  redirectToReviewPage,
  redirectToAccountDetails,
  redirectToBDDReviewScreen,
  processSaveandResume,
  saveInitialScreensInfo,
  redirectToBusinessTypePage,
  savePersonalInfo,
  redirectToBusinessMandateProduct,
  redirectToCustomerDetailsReview,
  redirectToEnterLinkCodePage,
  redirectToDocumentVersionPage,
  redirectToPersonalInfo,
  redirectToExit,
  redirectToPage
} from '../../store/dataCapture';
import {
  ROUTE_USERNAME_PASSWORD_PAGE,
  ROUTE_ACCOUNT_DETAILS_PAGE,
  BDD_REVIEW_PAGE,
  ROUTE_REVIEW_PAGE,
  SAVE_AND_RESUME_CAPTURE,
  BUSINESS_TYPE,
  NAVIGATION_BACK,
  LINK_CODE_KEY,
  GET_NEXT_APPLICANT_WAITING_REFER,
  ROUTE_PERSONAL_INFO_PAGE,
  LINK_CODE_RESUME_FLOW,
  RESUME_KEY,
  ROUTE_RESUME_PAGE,
  ROUTE_DOCUMENT_VERSION_PAGE
} from '../../utils/constants';
import {
  validateRouteToRedirect,
  getHrefOnBrowserLoad,
  getQueryStringValueByName,
  isBackNavigation,
  isExitNavigation,
  getStartPage
} from '../../utils';
import { isValidPage } from '../../infrastructure/config/action.helper';
import { INITIAL_SCREEN_DATA, PERSONAL_INFO_DATA } from '../../store/dataCapture/initialScrensData';
import {
  GET_NEXT_TASK_URI_KEYS,
  validateTaskUriToRedirect
} from '../../infrastructure/offers/action.helper';
import sessionRedirectUtil from '../../utils/sessionRedirectUtils';
import { resumeType } from '../../infrastructure/config/selectors';

class AppBootstrapComponent extends Component {
  constructor() {
    super();
    this.redirectToOfferScreens = this.redirectToOfferScreens.bind(this);
    this.redirectToPreviousRoute = this.redirectToPreviousRoute.bind(this);
    this.redirectToDocumentVersionPage = this.redirectToDocumentVersionPage.bind(this);
  }

  /**
   * Use to identify route params to redirection of pages
   */
  componentDidMount() {
    const { resumeType, redirectToPage } = this.props;
    if (isBackNavigation()) {
      this.redirectToPreviousRoute();
    } else if (isExitNavigation()) {
      this.props.redirectToExit();
    } else if (validateRouteToRedirect(ROUTE_USERNAME_PASSWORD_PAGE)) {
      this.props.redirectToUsernamePasswordPage();
    } else if (validateRouteToRedirect(ROUTE_ACCOUNT_DETAILS_PAGE)) {
      this.props.redirectToAccountDetails();
    } else if (validateRouteToRedirect(BDD_REVIEW_PAGE)) {
      this.props.redirectToBDDReviewScreen();
    } else if (validateRouteToRedirect(ROUTE_REVIEW_PAGE)) {
      this.props.redirectToReviewPage();
    } else if (validateRouteToRedirect(ROUTE_PERSONAL_INFO_PAGE)) {
      this.props.saveInitialScreensInfo(INITIAL_SCREEN_DATA);
      this.props.redirectToPersonalInfo();
    } else if (resumeType === RESUME_KEY) {
      redirectToPage(ROUTE_RESUME_PAGE);
    } else if (validateRouteToRedirect(ROUTE_DOCUMENT_VERSION_PAGE)) {
      this.props.redirectToDocumentVersionPage();
    } else {
      this.redirectToOfferScreens();
    }
  }

  redirectToOfferScreens() {
    if (isValidPage(GET_NEXT_TASK_URI_KEYS)) {
      this.props.processSaveandResume(getHrefOnBrowserLoad());
    } else if (validateRouteToRedirect(SAVE_AND_RESUME_CAPTURE)) {
      this.props.redirectToPage(getStartPage());
    } else if (getQueryStringValueByName(LINK_CODE_KEY)) {
      this.props.redirectToEnterLinkCodePage();
    } else if (!validateTaskUriToRedirect(GET_NEXT_APPLICANT_WAITING_REFER)) {
      const url = sessionRedirectUtil.getRefreshUrl();
      sessionRedirectUtil.redirectOnRefresh();
      if (url && url.indexOf(LINK_CODE_KEY) > -1) {
        this.props.redirectToEnterLinkCodePage();
      } else {
        this.props.redirectToPage(getStartPage());
      }
    }
  }

  redirectToPreviousRoute() {
    if (validateRouteToRedirect(ROUTE_USERNAME_PASSWORD_PAGE)) {
      INITIAL_SCREEN_DATA.businessTypeField = getQueryStringValueByName(BUSINESS_TYPE);
      this.props.saveInitialScreensInfo(INITIAL_SCREEN_DATA);
      this.props.savePersonalInfo(PERSONAL_INFO_DATA);
      this.props.redirectToBusinessTypePage();
    }
    if (isLinkCodeResumeFlow()) {
      this.props.saveInitialScreensInfo(INITIAL_SCREEN_DATA);
      this.props.redirectToPage(getStartPage());
    } else if (
      validateRouteToRedirect(ROUTE_ACCOUNT_DETAILS_PAGE) ||
      (validateRouteToRedirect(BDD_REVIEW_PAGE) && getQueryStringValueByName(LINK_CODE_KEY))
    ) {
      this.props.redirectToUsernamePasswordPage();
    } else if (validateRouteToRedirect(BDD_REVIEW_PAGE)) {
      this.props.redirectToBusinessMandateProduct();
    } else if (validateRouteToRedirect(ROUTE_REVIEW_PAGE)) {
      this.props.redirectToCustomerDetailsReview(NAVIGATION_BACK, {
        linkCodeResume: getQueryStringValueByName(LINK_CODE_RESUME_FLOW)
      });
    } else {
      sessionRedirectUtil.redirectOnRefresh();
    }
  }

  redirectToDocumentVersionPage() {
    this.props.redirectToDocumentVersionPage();
  }

  render() {
    return <span />;
  }
}

const actionCreators = {
  redirectToExit,
  redirectToUsernamePasswordPage,
  redirectToAccountDetails,
  redirectToBDDReviewScreen,
  redirectToReviewPage,
  isValidPage,
  saveInitialScreensInfo,
  redirectToPage,
  processSaveandResume,
  redirectToDocumentVersionPage,
  redirectToEnterLinkCodePage,
  redirectToBusinessTypePage,
  savePersonalInfo,
  redirectToBusinessMandateProduct,
  redirectToCustomerDetailsReview,
  redirectToPersonalInfo
};
const mapState = state => ({
  resumeType: resumeType(state)
});
const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

const isLinkCodeResumeFlow = () =>
  getQueryStringValueByName(LINK_CODE_RESUME_FLOW) && validateRouteToRedirect(BDD_REVIEW_PAGE);

export default connect(mapState, mapDispatchToProps)(AppBootstrapComponent);
